// Components==============
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import Search from 'components/UI/Search/Search';
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { SkillModalContext } from '../SkillModal';
import './SkillView.module.scss';
// =========================

const Skills = ({
  skills,
  type,
}: {
  skills: (SkillEntity | undefined)[];
  type: 'soft' | 'hard';
}) => {
  const {
    setSelected,
    selectedSparks,
    setShowOverview,
    handleSelectSkill,
    usedSkills,
  } = useContext(SkillModalContext);

  const translate = useTranslate();

  const { closeModal } = useRootModal();

  if (!skills.length) return <></>;

  return (
    <div>
      <strong styleName={type}>
        {translate(`general.terms.${type}`)} {translate('general.terms.skills')}
      </strong>
      <div styleName="skills">
        {skills?.map((skill) => {
          const sparkCount = selectedSparks
            ? selectedSparks.filter((s) => s.skill_id === skill?.id).length
            : 0;

          return (
            !!skill && (
              <ReflectionIcon
                key={skill.id}
                onClick={() => {
                  setSelected(skill);
                  setShowOverview(false);
                }}
                name={skill.name}
                image={`/storage/${skill.icon}`}
                count={sparkCount}
                type="skill"
                plusFunction={
                  handleSelectSkill
                    ? (e) => {
                        e.stopPropagation();
                        handleSelectSkill(skill.id);
                        return closeModal();
                      }
                    : undefined
                }
                used={usedSkills?.includes(skill?.id)}
              />
            )
          );
        })}
      </div>
    </div>
  );
};

export default function SkillView({ inProject }: { inProject: Boolean }) {
  const [value, setValue] = useState('');
  const translate = useTranslate();

  const skills = useRedux((state) =>
    state.skill?.entities.allIds
      .map((id) => state.skill?.entities.byId[id])
      .filter((skill) =>
        skill?.name.toLowerCase().includes(value.toLowerCase())
      )
  );

  const softSkills = skills?.filter((skill) => skill?.type === 'soft');
  const hardSkills = skills?.filter((skill) => skill?.type === 'hard');

  return (
    <div styleName="wrapper">
      <div styleName="top">
        <h3>
          {inProject
            ? translate('project.actions.allocate-sparks')
            : translate('reflection.which-skills')}
        </h3>
        <Search value={value} setValue={setValue} />
      </div>
      {softSkills && <Skills skills={softSkills} type="soft" />}
      {hardSkills && <Skills skills={hardSkills} type="hard" />}
    </div>
  );
}
